module.exports = __webpack_public_path__ + "img/newebpay_logo.0c9c183d.png";